var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 106,
    viewBox: "0 0 211 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_976_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6876 100C31.2553 99.6833 25.8975 99.43 20.4653 99.1133C18.0841 98.48 13.6193 96.96 9.6009 93.4766C2.75482 87.6499 2.0851 80.2398 2.01068 77.5797C1.93627 75.6164 2.0851 68.6496 8.11262 62.2529C9.45207 60.8595 13.9169 56.1728 22.028 54.2728C32.6692 51.8028 41.3756 55.9828 43.0872 56.8695C42.9383 55.1595 42.9383 52.6894 43.3104 49.7761C43.8313 46.1027 44.7243 39.7693 50.1565 33.8159C55.3654 28.0525 61.9883 25.7725 63.8486 25.2024C75.3084 21.5291 85.5031 24.9491 87.8843 25.8358C87.9587 24.1891 88.3308 21.8457 89.3726 19.1224C92.498 11.649 99.2697 7.65891 102.544 5.75889C104.851 4.42887 110.134 1.45217 118.022 0.37549C128.44 -1.01786 136.477 1.83217 139.528 2.97219C142.504 4.04887 151.508 7.53224 157.759 16.1457C163.786 24.4424 163.786 32.5492 163.563 35.5259C166.242 35.2092 169.888 34.9559 174.204 35.3359C175.842 35.4626 181.274 36.0326 186.855 38.1226C199.803 42.9993 205.607 53.3861 205.83 53.8928C213.867 68.7763 204.193 82.9631 203.3 84.2932C201.589 86.6999 196.231 93.6033 185.813 97.4666C181.869 98.9233 178.223 99.5567 175.693 99.81C129.407 99.8733 83.0474 99.9367 36.6876 100Z",
    fill: "#FFF7FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_976_587",
    x: 0,
    y: 0,
    width: 211,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_976_587",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud1.31a418cc2fbf53c0e9f139b4234dc50b.svg";
export { ForwardRef as ReactComponent };